import { compose } from 'recompose';
import ActiveTabTitle from './activeTabTitle';

const enhance = compose();

export default enhance(ActiveTabTitle);
